exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@-webkit-keyframes Animation__opacity-in___x0UhH {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes Animation__opacity-in___x0UhH {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes Animation__opacity-out___2riRI {\n  100% {\n    opacity: 0; } }\n\n@keyframes Animation__opacity-out___2riRI {\n  100% {\n    opacity: 0; } }\n\n.Animation__opacityIn___U5qVX {\n  opacity: 0;\n  -webkit-animation: Animation__opacity-in___x0UhH 2s linear 0s 1 forwards;\n          animation: Animation__opacity-in___x0UhH 2s linear 0s 1 forwards; }\n\n.Animation__opacityOut___7dOaA {\n  opacity: 1;\n  -webkit-animation: Animation__opacity-out___2riRI 2s linear 1s 1 forwards;\n          animation: Animation__opacity-out___2riRI 2s linear 1s 1 forwards; }\n", ""]);

// exports
exports.locals = {
	"opacityIn": "Animation__opacityIn___U5qVX",
	"opacity-in": "Animation__opacity-in___x0UhH",
	"opacityOut": "Animation__opacityOut___7dOaA",
	"opacity-out": "Animation__opacity-out___2riRI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/styles/Animation.scss
// module id = 170
// module chunks = 0